import { apiRequest } from '../client'
import type {
  AdminUser,
  CreateUserRequest,
  UpdateUserRequest,
  UpdateUserRolesRequest,
  UsersListResponse,
} from '../types'

interface UsersListParams {
  search?: string
  role?: string
  status?: 'active' | 'disabled'
  page?: number
  pageSize?: number
  tenantId?: number | null
}

function withTenantId(path: string, tenantId?: number | null) {
  if (!tenantId) return path
  const params = new URLSearchParams({ tenantId: tenantId.toString() })
  return `${path}?${params.toString()}`
}

export const usersApi = {
  list: (params?: UsersListParams) => {
    const query = new URLSearchParams()
    if (params?.search) query.set('search', params.search)
    if (params?.role) query.set('role', params.role)
    if (params?.status) query.set('status', params.status)
    if (params?.page !== undefined) query.set('page', params.page.toString())
    if (params?.pageSize !== undefined)
      query.set('pageSize', params.pageSize.toString())
    if (params?.tenantId) query.set('tenantId', params.tenantId.toString())
    const qs = query.toString()
    return apiRequest<UsersListResponse>(
      `/api/v0/admin/users${qs ? `?${qs}` : ''}`,
    )
  },

  get: (id: number, tenantId?: number | null) =>
    apiRequest<AdminUser>(withTenantId(`/api/v0/admin/users/${id}`, tenantId)),

  create: (data: CreateUserRequest, tenantId?: number | null) =>
    apiRequest<{ ok: boolean; id: number; user: AdminUser }>(
      withTenantId('/api/v0/admin/users', tenantId),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
    ),

  update: (id: number, data: UpdateUserRequest, tenantId?: number | null) =>
    apiRequest<{ ok: boolean; user: AdminUser }>(
      withTenantId(`/api/v0/admin/users/${id}`, tenantId),
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
    ),

  updateRoles: (
    id: number,
    data: UpdateUserRolesRequest,
    tenantId?: number | null,
  ) =>
    apiRequest<{ ok: boolean; user: AdminUser }>(
      withTenantId(`/api/v0/admin/users/${id}/roles`, tenantId),
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
    ),
}
